import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqItemsService } from '../services/constructionBoqItems.service';
import type { ConstructionBoqItem } from '../types/construction-boq.types';
import { toast } from 'sonner';

export function useUpdateBoqItem(boqId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, updates }: { itemId: string, updates: Partial<ConstructionBoqItem> }) => 
      ConstructionBoqItemsService.updateBoqItem(itemId, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'items', boqId] });
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'stats', boqId] });
      toast.success('Cập nhật hạng mục thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi cập nhật: ' + error.message);
    }
  });
}
